import { render, staticRenderFns } from "./PrivateHomeView.vue?vue&type=template&id=6d34d466&scoped=true"
import script from "./PrivateHomeView.vue?vue&type=script&lang=js"
export * from "./PrivateHomeView.vue?vue&type=script&lang=js"
import style0 from "./PrivateHomeView.vue?vue&type=style&index=0&id=6d34d466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d34d466",
  null
  
)

export default component.exports